import * as React from 'react';

function CircleCloseIcon({'aria-hidden': ariaHidden=true,  ...props}: React.SVGProps<SVGSVGElement>) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      xmlnsXlink="http://www.w3.org/1999/xlink"
      width="24"
      height="24"
      viewBox="0 0 24 24"
      aria-hidden={ariaHidden}
      {...props}
    >
      <defs>
        <path
          id="eatazk6w9a"
          d="M14.142 4.142c-5.523 0-10 4.477-10 10s4.477 10 10 10 10-4.477 10-10c0-2.652-1.053-5.196-2.929-7.07-1.875-1.876-4.419-2.93-7.07-2.93zm3.3 11.1h-2.2v2.2c0 .608-.492 1.1-1.1 1.1-.607 0-1.1-.492-1.1-1.1v-2.2h-2.2c-.607 0-1.1-.492-1.1-1.1 0-.607.493-1.1 1.1-1.1h2.2v-2.2c0-.607.493-1.1 1.1-1.1.608 0 1.1.493 1.1 1.1v2.2h2.2c.608 0 1.1.493 1.1 1.1 0 .608-.492 1.1-1.1 1.1z"
        />
      </defs>
      <g fill="none" fillRule="evenodd">
        <g>
          <g>
            <g transform="translate(-701 -247) translate(29 233) translate(669.858 11.858)">
              <path d="M2.142 2.142H26.142V26.142H2.142z" />
              <mask id="yf9uyj8vab" fill="#fff">
                <use xlinkHref="#eatazk6w9a" />
              </mask>
              <use fill="#383C52" fillRule="nonzero" transform="rotate(-45 14.142 14.142)" xlinkHref="#eatazk6w9a" />
              <g fill="#383C52" mask="url(#yf9uyj8vab)">
                <path d="M0 0H24V24H0z" transform="translate(2.142 2.142)" />
              </g>
            </g>
          </g>
        </g>
      </g>
    </svg>
  );
}

export default CircleCloseIcon;
